import { Navbar } from 'components';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AboutScreen, Landing, ProductDetails, ServicesScreen } from 'screens';
import { ContactScreen } from 'screens/ContactScreen/ContactScreen';
import { Footer } from 'screens/Footer';
import NotFound from 'screens/NotFound/NotFound';

function App() {
  const [prevScrollPos, setPrevScrollPos] = useState(window.pageYOffset);
  const [navbarHidden, setNavbarHidden] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isScrollingDown =
        prevScrollPos < currentScrollPos && currentScrollPos > 50;

      setNavbarHidden(isScrollingDown);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos]);

  return (
    <Router>
      <Navbar hidden={navbarHidden} />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/product-details/:type/:title"
          element={<ProductDetails />}
        />
        <Route path="/about" element={<AboutScreen />} />
        <Route path="/services" element={<ServicesScreen />} />
        <Route path="/contact" element={<ContactScreen />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
